'use client';

import { useEffect } from 'react';
import { reportFetchFailure } from '~/utilities/flp/reportClientError';

type OwnProps = {
  location: string;
  toastMessage?: string;
};

export default function FetchFailureNotice({
  location,
  toastMessage
}: OwnProps) {
  useEffect(() => {
    reportFetchFailure(location, toastMessage);
  }, [location, toastMessage]);

  return null;
}
